module.exports = __webpack_public_path__ + "static/media/Ra.d94a24b7.jpg";